import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "@/assets/main.css";
import "primeicons/primeicons.css";
import { createPinia } from "pinia";
import PrimeVue from "primevue/config";
import Aura from "@primevue/themes/aura";
import { definePreset } from "@primevue/themes";
import ToastService from "primevue/toastservice";
import Tooltip from "primevue/tooltip";

const pinia = createPinia();

const graphaloPreset = definePreset(Aura, {
  semantic: {
    colorScheme: {
      light: {
        // https://www.tailwindshades.com/#color=301.57894736842104%2C67.85714285714285%2C67.05882352941177&step-up=8&step-down=11&hue-shift=0&name=primary&base-stop=5&v=1&overrides=e30%3D
        primary: {
          DEFAULT: "#DB43D7",
          50: "#ffedff",
          100: "#efcfee",
          200: "#F1B6F0",
          300: "#EB94E8",
          400: "#E472E1",
          500: "#DB43D7",
          600: "#C125BD",
          700: "#921C8F",
          800: "#631361",
          900: "#4B0E4A",
          950: "#340934",
          color: "{primary-500}",
          // inverseColor: "{surface-100}",
          // hoverColor: "{surface-900}",
          // activeColor: "{surface-800}",
        },
        // https://www.tailwindshades.com/#color=240%2C26.666666666666668%2C23.52941176470588&step-up=19&step-down=6&hue-shift=0&name=surface&base-stop=7&v=1&overrides=e30%3D
        surface: {
          0: "#ffffff",
          50: "{slate-50}",
          100: "{slate-100}",
          200: "{slate-200}",
          300: "{slate-300}",
          400: "{slate-400}",
          500: "{slate-500}",
          600: "{slate-600}",
          700: "{slate-700}",
          800: "{slate-800}",
          900: "{slate-900}",
          950: "{slate-950}",
          1000: "#000000",
        },
        // highlight: {
        //   background: "{primary-100}",
        //   focusBackground: "{primary-200}",
        //   color: "{surface-950}",
        //   focusColor: "{surface-950}",
        // },
      },
      dark: {
        primary: {
          DEFAULT: "#E472E1",
          50: "#FFFFFF",
          100: "#FEFBFE",
          200: "#F8D9F7",
          300: "#F1B6F0",
          400: "#EB94E8",
          500: "#E472E1",
          600: "#DB43D7",
          700: "#C125BD",
          800: "#921C8F",
          900: "#631361",
          950: "#4B0E4A",
          color: "{primary-500}",
          // inverseColor: "{surface-100}",
          // hoverColor: "{surface-900}",
          // activeColor: "{surface-800}",
        },
        surface: {
          DEFAULT: "#2C2C4C",
          50: "#FFFFFF",
          100: "#FFFFFF",
          200: "#FFFFFF",
          300: "#FDFDFE",
          400: "#C0C0DB",
          500: "#8383B7",
          600: "#505089",
          700: "#2C2C4C",
          800: "#212139",
          900: "#161625",
          950: "#10101C",
        },
      },
    },
  },
});

const app = createApp(App);
app.use(router);
app.use(ToastService);
app.use(pinia);
app.use(PrimeVue, {
  theme: {
    prefix: "p",
    preset: graphaloPreset,
    options: {
      darkModeSelector: ".dark",
    },
  },
  pt: {
    tabpanels: {
      root: {
        style: "padding: 0;",
      },
    },
    tablist: {
      activeBar: {
        style: "background: var(--p-primary-500); height: 2px",
      },
    },
    tree: {
      nodeContent: "!p-0",
      nodeLabel: "w-full",
      pcFilterIconContainer: { root: "!right-5" },
    },
    pcPaginator: { current: "mx-4" }, // space before results total row count
  },
});
app.directive("tooltip", Tooltip);
app.mount("#app");
